import React from 'react';

export default function ErrorPage() {
    return (
        <h1>Oopsie! Looks like something went horribly horribly wrong!</h1>
    )
}